import { useSyncExternalStore } from 'react';
import {
    appCommit,
    appVersion,
    applyAppUpdate,
    checkForAppUpdate,
    dismissAppUpdate,
    getAppUpdateState,
    isUpdateWaiting,
    subscribeToAppUpdate,
} from '../lib/appUpdate';

export interface AppUpdate {
    /** Waiting and not dismissed. Drives the prompt. */
    available: boolean;
    /** Waiting, dismissed or not. The install screen offers it either way. */
    waiting: boolean;
    checking: boolean;
    lastCheckedAt: Date | null;
    /** Formatted for display. */
    version: string;
    commit: string;
    newVersion: string | null;
    apply: () => void;
    dismiss: () => void;
    checkNow: () => void;
}

export const useAppUpdate = (): AppUpdate => {
    const state = useSyncExternalStore(subscribeToAppUpdate, getAppUpdateState, getAppUpdateState);
    const waiting = isUpdateWaiting();

    return {
        waiting,
        // Dismissal is remembered against the version dismissed, so a newer one
        // still asks while this one stays quiet.
        available: waiting && state.dismissedVersion !== state.serverVersion,
        checking: state.checking,
        lastCheckedAt: state.lastCheckedAt,
        version: appVersion(),
        commit: appCommit(),
        newVersion: state.serverVersion,
        apply: applyAppUpdate,
        dismiss: dismissAppUpdate,
        checkNow: checkForAppUpdate,
    };
};
